import React from 'react';
import Navbar from './Navbar';
import './Navigation.css';

function Header() {
  return (
    <div className="header">
      <Navbar />
    </div>
  );
}
export default Header;
